import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonFunctionalitiesService } from '@app/services/common-functionalities.service';

@Component({
  selector: 'app-duration-show',
  templateUrl: './duration-show.component.html',
  styleUrls: ['./duration-show.component.scss']
})
export class DurationShowComponent implements OnInit, OnDestroy {

  /****************** Variable declaration ******************/
  time: string | undefined;
  interval: any;

  /****************** Input and Output decorators ******************/
  @Input() timeInSec!: number; //input to be taken from parent components

  /**
   * Constructor
   * @param cf 
   */
  constructor(private cf: CommonFunctionalitiesService) {
  }

  /** ngOnInit */
  ngOnInit(): void {
    this.updateTimeInterval()

    this.interval = setInterval(() => {
      this.updateTimeInterval()
    }, 1000);
  }

  /** update time interval */
  updateTimeInterval(): void {
    this.time = this.cf.getDurationFromSeconds(this.timeInSec++);
  }

  /** ngOnDestroy */
  ngOnDestroy(): void {
    clearInterval(this.interval);
  }
}
